module.exports = __webpack_public_path__ + "img/8.9cf5e268.jpg";